import { createContext, useContext, useEffect, useState } from 'react';
import { IParent } from '../../components/common/types';
import { useLocation } from 'react-router-dom';

export enum Path {
	ERROR = '_' /** Null token */,
	HOME = '/',
	GAME = '/game',
}

interface IProvider {
	current: Path;
}

export const emptyContext: IProvider = {
	current: Path.HOME,
};

export const PathProvider = ({ children }: IParent) => {
	const [current, setCurrent] = useState(emptyContext.current);

	const { pathname } = useLocation();

	useEffect(() => {
		for (const key of Object.keys(Path)) {
			const value = Path[key as keyof typeof Path];

			if (
				value !== Path.ERROR /** Skip err route */ &&
				value !== Path.HOME /** Skip root route */ &&
				pathname.startsWith(value) /** Check valid routes */
			) {
				setCurrent(value);

				return;
			}

			/** Root edge case */
			if (value === Path.HOME && value === pathname) {
				setCurrent(value);

				return;
			}
		}

		/** Catch `*` paths */
		setCurrent(Path.ERROR);
	}, [pathname]);

	return <Context.Provider value={{ current }}>{children}</Context.Provider>;
};

const Context = createContext(emptyContext);

export const usePathProvider = () => {
	return useContext(Context);
};
